import { FunctionComponent } from 'react';
import { Invoice } from 'src/types/invoice';
import {
    StatusBadge,
    InvoiceLink,
    InvoicesCellCenter,
    InvoicesCellActions,
    InvoicesDataRow,
    InvoicesDataCell
} from './styled';
import {
    formatBillingReason,
    formatCents,
    formatDate
} from './invoiceFormatters';

interface Props {
    invoice: Invoice;
}

const InvoicesTableDataRow: FunctionComponent<Props> = ({ invoice }) => (
    <InvoicesDataRow>
        <InvoicesDataCell>
            <InvoicesCellCenter>
                <StatusBadge status={invoice.status}>
                    {invoice.status}
                </StatusBadge>
            </InvoicesCellCenter>
        </InvoicesDataCell>
        <InvoicesDataCell>
            <InvoicesCellCenter>
                {formatCents(invoice.total_cents, invoice.currency)}
            </InvoicesCellCenter>
        </InvoicesDataCell>
        <InvoicesDataCell>
            <InvoicesCellCenter>
                {formatBillingReason(invoice.billing_reason)}
            </InvoicesCellCenter>
        </InvoicesDataCell>
        <InvoicesDataCell>
            <InvoicesCellCenter>
                {formatDate(invoice.period_start)}
                {' — '}
                {formatDate(invoice.period_end)}
            </InvoicesCellCenter>
        </InvoicesDataCell>
        <InvoicesDataCell>
            <InvoicesCellCenter>
                {formatDate(invoice.due_date)}
            </InvoicesCellCenter>
        </InvoicesDataCell>
        <InvoicesDataCell>
            <InvoicesCellCenter>
                {formatDate(invoice.paid_at)}
            </InvoicesCellCenter>
        </InvoicesDataCell>
        <InvoicesDataCell>
            <InvoicesCellActions>
                {invoice.hosted_invoice_url && (
                    <InvoiceLink
                        href={invoice.hosted_invoice_url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View
                    </InvoiceLink>
                )}
                {invoice.invoice_pdf && (
                    <InvoiceLink
                        href={invoice.invoice_pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        PDF
                    </InvoiceLink>
                )}
            </InvoicesCellActions>
        </InvoicesDataCell>
    </InvoicesDataRow>
);

export default InvoicesTableDataRow;
